import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  CreateOrder,
  Orders,
  DetailOrder,
  CreateExport,
  Exports,
  DetailExport,
  CreateOrderStock,
  EditOrder,
  EditExport,
  CreateOrderReturn,
  EditOrderReturn,
  DetailOrderReturn,
  OrdersReturn,
  DetailOrderLog,
  DetailOrderReturnLog,
  DetailExportLog,
} from '../views/SPM';
import { HomeNavbar } from '../components/Navbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { Loading } from '../components/Loading';
import { NotFound, NotAuthorized } from '../components/Error';
import accessRight from '../utils/functions/accessRight';
import * as actions from '../redux/actions';
import CreateOrderStockMany from '../views/SPM/CreateOrderStockMany';
import CreateOrderMany from '../views/SPM/CreateOrderMany';
import CreateExportMany from '../views/SPM/CreateExportMany';
// Sales and Purchase Management
export const SPM = () => {
  const module = 'SPM';
  const prefix = '/spm';
  const name = 'จัดการคำสั่งซื้อ';

  const dispatch = useDispatch();
  const me = useSelector((state) => state.me);
  const availableModule = useSelector((state) => state.availableModule);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    console.log('Layout: SPM');
    dispatch(actions.meGet());
    dispatch(actions.availableModuleAll());
    return () => { };
  }, []);

  if (!me?.userData) {
    return <Loading />;
  }

  if (accessRight(me, module, 0, availableModule)) {
    return (
      <div className="min-h-screen">
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="min-h-screen  pt-16 px-4 flex w-full">
          <MainSidebar
            onMobileClose={handleOnMobileNavClose}
            openMobile={isMobileNavOpen}
            me={me}
          />
          <div className="py-4 w-full">
            <Switch>
              <Redirect exact from={`${prefix}`} to={`${prefix}/orders`} />
              {/* <Route exact path={`${prefix}/online`}>
                <Onlines title="ขายออนไลน์" subtitle={name} />
              </Route> */}
              <Route exact path={`${prefix}/orders`}>
                <Orders title="การนำเข้าสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/orders/create`}>
                <CreateOrder title="เพิ่มการนำเข้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/orders/create_many`}>
                <CreateOrderMany title="เพิ่มการนำเข้าหลายสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/orders/create_stock`}>
                <CreateOrderStock title="นำสินค้าลงคลัง" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/orders/create_stockmany`}>
                <CreateOrderStockMany title="นำสินค้าลงคลังหลายสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/orders/:id`}>
                <DetailOrder title="รายละเอียดการนำเข้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/orders/log/:id`}>
                <DetailOrderLog
                  title="รายละเอียดการนำเข้า (Log)"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/order-return`}>
                <OrdersReturn title="การรับคืนสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/order-return/create`}>
                <CreateOrderReturn
                  title="สร้างการรับคืนสินค้า"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/order-return/edit/:id`}>
                <EditOrderReturn
                  title="แก้ไขการนำรับคืนสินค้า"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/order-return/:id`}>
                <DetailOrderReturn
                  Return
                  title="รายละเอียดการรับคืนสินค้า"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/order-return/log/:id`}>
                <DetailOrderReturnLog
                  title="รายละเอียดการรับคืนสินค้า (Log)"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/order/edit/:id`}>
                <EditOrder title="แก้ไขการนำเข้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/export/edit/:id`}>
                <EditExport title="แก้ไขการส่งออก" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/exports`}>
                <Exports title="การส่งออกสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/exports/create`}>
                <CreateExport title="เพิ่มการส่งออก" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/exports/create_many`}>
                <CreateExportMany title="เพิ่มการส่งออกหลายสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/exports/:id`}>
                <DetailExport title="รายละเอียดการส่งออก" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/exports/log/:id`}>
                <DetailExportLog
                  title="รายละเอียดการส่งออก (Log)"
                  subtitle={name}
                />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <NotAuthorized />
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    </div>
  );
};

export default SPM;
